import {
  Button,
  Col,
  DatePicker,
  Form,
  message,
  Modal,
  Row,
  Space,
  Tag,
  Tooltip,
} from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, { useEffect, useMemo, useState } from 'react'
import SelectGroupPopup from '../../../components/SelectGroupPopup/SelectGroupPopup'
import SelectPeoplePopup from '../../../components/SelectPeoplePopup/SelectPeoplePopup'
import {
  ASSIGNEE_TYPE,
  DATE_FORMAT_LIST,
  WORK_STATUS,
} from '../../../constants'
import {
  SelectList,
  SelectTitle,
  TitleModal,
} from '../PopupAddPersonWork/PopupAddPersonWorkStyled'
import { blue, yellowPrimary } from '../../../color'
import { BankOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons'
import { AvatarHasName } from '../../../components/Common/Avatar'

const PopupAddPersonWorkV2 = props => {
  const {
    isOpenModal,
    setIsOpenModal,
    selectPeopleStore,
    workStore,
    loadingAnimationStore,
  } = props

  const { workDetail } = workStore
  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
  } = selectPeopleStore
  const { assignees, work_type } = workDetail

  const [form] = Form.useForm()
  const { setFieldsValue } = form

  const [handlerList, setHandlerList] = useState([])
  const [followerList, setFollowerList] = useState([])

  const userList = useMemo(
    () =>
      assignees
        ? assignees.filter(
            el =>
              el.assignee_type === ASSIGNEE_TYPE.USER &&
              el.permission !== ASSIGNEE_TYPE.CREATE
          )
        : [],
    [assignees]
  )

  const departmentList = useMemo(
    () =>
      assignees
        ? assignees.filter(el => el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT)
        : [],
    [assignees]
  )

  const groupList = useMemo(
    () =>
      assignees
        ? assignees.filter(el => el.assignee_type === ASSIGNEE_TYPE.GROUP)
        : [],
    [assignees]
  )

  useEffect(() => {
    setHandlerList([
      ...selectUserData[ASSIGNEE_TYPE.HANDLER],
      ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
    ])
    setFollowerList([
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  useEffect(() => {
    if (!isOpenModal) return

    selectPeopleStore.setSelectUserData(
      selectPeopleStore.convertSelectDataObj(userList)
    )

    selectPeopleStore.setSelectDepartmentData(
      selectPeopleStore.convertSelectDataObj(departmentList)
    )

    selectPeopleStore.setSelectGroupData(
      selectPeopleStore.convertSelectDataObj(groupList)
    )

    if (workDetail.due_date) {
      setFieldsValue({
        due_date: moment(workDetail.due_date),
      })
    } else {
      setFieldsValue({
        due_date: undefined,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenModal, userList, departmentList, groupList, workDetail])

  const handleCancel = () => {
    form.resetFields()

    setHandlerList([])
    setFollowerList([])

    setIsOpenModal(false)
  }

  const isElectronicWork = work_type === WORK_STATUS.ELECTRONIC

  const handleSubmit = async () => {
    try {
      loadingAnimationStore.showSpinner(true)
      const code_work = workDetail?.code
      const dueDate = form.getFieldValue('due_date') // Lấy ngày kết thúc
      const startDate = workDetail?.start_date // Lấy ngày bắt đầu

      // Kiểm tra nếu ngày kết thúc nhỏ hơn ngày bắt đầu
      if (dueDate && startDate && dueDate.isBefore(startDate, 'day')) {
        return message.error('Ngày kết thúc phải lớn hơn ngày bắt đầu!')
      }

      const new_items_assign = []
      const remove_items_assign = []
      const listAssignOrigin = [
        ...userList,
        ...departmentList,
        ...groupList,
      ].map(el => ({
        assignee_code: el.assignee_code,
        assignee_type: el.assignee_type,
        permission: el.permission,
      }))
      const listAssignAfter = [...followerList, ...handlerList].map(el => ({
        assignee_code: el.id,
        assignee_type: el.assignee_type,
        permission: el.permission,
      }))
      if (handlerList.length === 0) {
        return isElectronicWork
          ? message.info('Bạn chưa chọn lãnh đạo ký duyệt!')
          : message.info('Bạn chưa chọn người xử lý!')
      }
      listAssignAfter.forEach(assignAfter => {
        if (
          !listAssignOrigin.some(
            assignOrigin =>
              assignOrigin.assignee_code + assignOrigin.permission ===
              assignAfter.assignee_code + assignAfter.permission
          )
        ) {
          new_items_assign.push({
            assignee_code: assignAfter.assignee_code,
            assignee_type: assignAfter.assignee_type,
            permission: assignAfter.permission,
          })
        }
      })
      listAssignOrigin.forEach(assignOrigin => {
        if (
          !listAssignAfter.some(
            assignAfter =>
              assignAfter.assignee_code + assignAfter.permission ===
              assignOrigin.assignee_code + assignOrigin.permission
          )
        ) {
          remove_items_assign.push({
            assignee_code: assignOrigin.assignee_code,
            assignee_type: assignOrigin.assignee_type,
            permission: assignOrigin.permission,
          })
        }
      })
      const dataSubmit = {
        new_items: new_items_assign,
        remove_items: remove_items_assign,
        due_date: form.getFieldValue('due_date'),
      }
      await workStore.updatePeopleInvole(code_work, dataSubmit)
      workStore.getWorkDetail(code_work)
      message.success('Thêm người thành công!')
      handleCancel()
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  return (
    <Modal
      title="Thêm người"
      width={650}
      wrapClassName="custom-modal-wrapper"
      maskClosable={false}
      open={isOpenModal}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <SelectTitle>
            <span>
              <span
                style={{
                  color: '#ff4d4f',
                  fontFamily: 'SimSun, sans-serif',
                  marginRight: '-4px',
                }}>
                *{' '}
              </span>
              <span style={{ marginRight: '10px' }}>
                {isElectronicWork ? 'Lãnh đạo ký duyệt:' : 'Người xử lý:'}
              </span>
            </span>
            <Space>
              <Tooltip title="Chọn người dùng" color={blue}>
                <Button
                  className="select-user-icon-btn"
                  icon={<UserOutlined style={{ color: blue }} />}
                  onClick={() =>
                    handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.HANDLER)
                  }
                />
              </Tooltip>
              {!isElectronicWork && (
                <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                  <Button
                    className="select-user-icon-btn"
                    icon={<TeamOutlined />}
                    style={{ color: yellowPrimary }}
                    onClick={() =>
                      handleOpenSelectGroupPopup(ASSIGNEE_TYPE.HANDLER)
                    }
                  />
                </Tooltip>
              )}
            </Space>
          </SelectTitle>
          <SelectList>
            {handlerList.map(el => (
              <Tag
                className={'tag-selected'}
                color={'blue'}
                key={el.id}
                closable
                onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                <AvatarHasName
                  imgId={el.image_id}
                  size={22}
                  name={el.full_name}
                  icon={
                    (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                      <BankOutlined />
                    )) ||
                    (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                      <TeamOutlined />
                    ))
                  }
                />
              </Tag>
            ))}
          </SelectList>
        </Col>

        <Col span={24}>
          <SelectTitle>
            <span>
              <span style={{ marginRight: '10px' }}>Người theo dõi:</span>
            </span>
            <Space>
              <Tooltip title="Chọn người dùng" color={blue}>
                <Button
                  className="select-user-icon-btn"
                  icon={<UserOutlined style={{ color: blue }} />}
                  onClick={() =>
                    handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.FOLLOWER)
                  }
                />
              </Tooltip>
              <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                <Button
                  className="select-user-icon-btn"
                  icon={<TeamOutlined />}
                  style={{ color: yellowPrimary }}
                  onClick={() =>
                    handleOpenSelectGroupPopup(ASSIGNEE_TYPE.FOLLOWER)
                  }
                />
              </Tooltip>
            </Space>
          </SelectTitle>
          <SelectList>
            {followerList.map(el => (
              <Tag
                className={'tag-selected'}
                color={'blue'}
                key={el.id}
                closable
                onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                <AvatarHasName
                  imgId={el.image_id}
                  size={22}
                  name={el.full_name}
                  icon={
                    (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                      <BankOutlined />
                    )) ||
                    (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                      <TeamOutlined />
                    ))
                  }
                />
              </Tag>
            ))}
          </SelectList>
        </Col>
        <Col span={24}>
          <Form form={form} layout="vertical">
            <Form.Item
              label={'Ngày kết thúc:'}
              name={'due_date'}
              rules={[
                { required: false, message: 'Vui lòng chọn ngày kết thúc!' },
                () => ({
                  validator(_, value) {
                    const workDetailStartDate = workDetail.start_date
                    if (!workDetailStartDate || !value) {
                      return Promise.resolve()
                    }
                    if (value.isAfter(workDetailStartDate)) {
                      return Promise.resolve()
                    }
                    return Promise.reject(
                      'Ngày kết thúc phải lớn hơn ngày bắt đầu!'
                    )
                  },
                }),
              ]}>
              <DatePicker
                format={DATE_FORMAT_LIST}
                className="h-40"
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Form>
        </Col>
        <Col span={24}>
          <div className="custom-modal-footer">
            <Space>
              <Button
                danger
                className="custom-ant-button w-160"
                onClick={() => {
                  handleCancel()
                }}>
                Hủy
              </Button>
              <Button
                className="custom-ant-button w-160"
                type={'primary'}
                onClick={() => handleSubmit()}>
                Cập nhật
              </Button>
            </Space>
          </div>
        </Col>
      </Row>

      <SelectPeoplePopup
        onlyOneUser={
          isElectronicWork
            ? selectPeopleStore.assigneePopupType === ASSIGNEE_TYPE.HANDLER
            : false
        }
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
      />
      <SelectGroupPopup
        isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
        handleCancelSelectGroup={handleCancelSelectGroup}
        handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
      />
    </Modal>
  )
}

export default inject(
  'workStore',
  'selectPeopleStore',
  'loadingAnimationStore'
)(observer(PopupAddPersonWorkV2))
